// src/pages/collectes/CollectesUsagers.js
import React, { useState, useEffect, useCallback, useRef, useMemo } from "react";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import mairieLogo1 from "../assets/img/image.jpeg";
import mairieLogo from "../assets/img/nrf.png";
import { Link } from "react-router-dom";
import QRCode from "qrcode";
import {
  Card, Table, Row, Col, Form, InputGroup, Button, Pagination, Badge,
  Modal, Toast, ToastContainer, Spinner, FloatingLabel, Tab, Tabs, ProgressBar,
} from "react-bootstrap";
import axios from "axios";
import {
  Search, Eye, Download, Printer, Filter, Calendar, Cash, Wallet, Person,
  FileText, ClockHistory, ChevronDown, ChevronUp, ExclamationCircle,
  CheckCircle, XCircle, ArrowDownCircle, ArrowUpCircle, Receipt,
  CreditCard, Bank, Tag, FileEarmarkBarGraph, CurrencyDollar,
  InfoCircle, Phone, Envelope, Activity, Building, GeoAlt, Shop,
} from "react-bootstrap-icons";
import { API_BASE_URL } from "../constants/api_constants";
import {
  getUserRoleId,
  getUserRoles,
  isSuperAdmin as checkSuperAdmin,
  canFilterByMarketScope,
} from "../utils/auth";

// ✅ Liste blanche : seuls ces rôles peuvent filtrer par périmètre marché
const ALLOWED_MARKET_SCOPE_ROLES = [1002]; // Admin Entité

const PAYMENT_STATUS = {
  completed: { label: "Payé", color: "success" },
  pending: { label: "En attente", color: "warning" },
  failed: { label: "Échoué", color: "danger" },
};

export default function CollectesUsagers() {
  // États pour les données paginées
  const [paiements, setPaiements] = useState([]);
  const [pagination, setPagination] = useState({
    total: 0,
    current_page: 1,
    per_page: 10,
    last_page: 1,
    from: 0,
    to: 0,
  });

  // États pour les filtres
  const [filterText, setFilterText] = useState("");
  const [filters, setFilters] = useState({
    dateDebut: "",
    dateFin: "",
    statut: "",
    methode: "",
    taxeId: "",
    montantMin: "",
    montantMax: "",
    contribuableId: "",
  });

  // Options des filtres
  const [filterOptions, setFilterOptions] = useState({ taxes: [], contribuables: [] });

  const [stats, setStats] = useState({
    totalPaiements: 0,
    totalMontant: 0,
    paiementsReussis: 0,
    paiementsEchoues: 0,
    paiementsEnAttente: 0,
    paiementsAnnules: 0,
    montantMoyen: 0,
    montantCollecte: 0,
    montantNonCollecte: 0,
    montantEnAttente: 0,
  });

  // États d'interface
  const [showFilters, setShowFilters] = useState(false);
  const [sortField, setSortField] = useState("date_paiement");
  const [sortDirection, setSortDirection] = useState("desc");
  const [loading, setLoading] = useState(true);
  const [loadingStats, setLoadingStats] = useState(true);
  const [loadingExport, setLoadingExport] = useState(false);
  const [printingPaymentId, setPrintingPaymentId] = useState(null);
  const [error, setError] = useState(null);
  const [alertMessage, setAlertMessage] = useState({ show: false, message: "", type: "info" });
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedPaiement, setSelectedPaiement] = useState(null);
  const [selectedContribuableTaxes, setSelectedContribuableTaxes] = useState([]);
  const [loadingContribuableTaxes, setLoadingContribuableTaxes] = useState(false);
  const [loadingEcheancesDetails, setLoadingEcheancesDetails] = useState(false);
  const [echeanceDetails, setEcheanceDetails] = useState(null);

  // Localités
  const [localiteInfo, setLocaliteInfo] = useState(null);
  const [allLocalites, setAllLocalites] = useState([]);
  const [loadingLocalite, setLoadingLocalite] = useState(false);
  const LOCALITES_ENDPOINT = `${API_BASE_URL}/localites`;

  // Annulation
  const [cancelReason, setCancelReason] = useState("");
  const [cancelReasonError, setCancelReasonError] = useState("");
  const [showCancelConfirmModal, setShowCancelConfirmModal] = useState(false);
  const [paymentToCancel, setPaymentToCancel] = useState(null);
  const [cancellingPayment, setCancellingPayment] = useState(false);

  const defaultCurrency = sessionStorage.getItem("default_currency") || "XOF";
  const [loadingDetailsId, setLoadingDetailsId] = useState(null);

  // ✅ DÉTECTION STRICTE DES RÔLES
  const userRoleId = useMemo(() => {
    const id = getUserRoleId();
    console.log("🔍 [CollectesUsagers] role_id détecté :", id);
    return id || 0;
  }, []);
  const isSuperAdmin = useMemo(() => checkSuperAdmin(), []);
  const isAdminEntite = userRoleId === 1002;

  // ✅ Double sécurité : uniquement Admin Entité OU Super Admin
  const canUseMarketScope = useMemo(() => {
    if (isSuperAdmin === true) return true;
    if (ALLOWED_MARKET_SCOPE_ROLES.includes(userRoleId)) return true;
    return false;
  }, [isSuperAdmin, userRoleId]);

  // ✅ Périmètre marché
  const [marketScope, setMarketScope] = useState("all");

  useEffect(() => {
    console.log("🔍 [CollectesUsagers] role_id :", userRoleId);
    console.log("🔍 [CollectesUsagers] isAdminEntite :", isAdminEntite);
    console.log("🔍 [CollectesUsagers] isSuperAdmin :", isSuperAdmin);
    console.log("🔍 [CollectesUsagers] canUseMarketScope :", canUseMarketScope);
    try {
      console.log(
        "🔍 [CollectesUsagers] userRoles bruts :",
        getUserRoles ? getUserRoles() : "non importé"
      );
    } catch (e) {
      console.warn("Impossible de lire userRoles:", e);
    }
  }, [userRoleId, isAdminEntite, isSuperAdmin, canUseMarketScope]);

  const getAuthToken = () => sessionStorage.getItem("authToken");

  const getHeaders = () => {
    const token = getAuthToken();
    const headers = { "Content-Type": "application/json", Accept: "application/json" };
    if (token) headers["Authorization"] = `Bearer ${token}`;
    return headers;
  };

  // ✅ Helper : renvoie le market_scope à envoyer
  const effectiveMarketScope = () => (canUseMarketScope ? marketScope : "all");

  const showAlert = (message, type = "info", duration = 4000) => {
    setAlertMessage({ show: true, message, type });
    if (duration > 0)
      setTimeout(() => setAlertMessage((prev) => ({ ...prev, show: false })), duration);
  };

  const formatCurrency = (amount) => {
    const num = parseFloat(amount) || 0;
    return (
      num.toLocaleString("fr-FR", { minimumFractionDigits: 0, maximumFractionDigits: 0 }) +
      " " +
      defaultCurrency
    );
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString("fr-FR", {
        day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit",
      });
    } catch (e) {
      return dateString;
    }
  };

  const getStatusBadge = (statut) => {
    const statusConfig = {
      completed: { label: "Payé", color: "success", icon: <CheckCircle size={12} className="me-1" /> },
      pending: { label: "En attente", color: "warning", icon: <ClockHistory size={12} className="me-1" /> },
      failed: { label: "Échoué", color: "danger", icon: <XCircle size={12} className="me-1" /> },
      cancelled: { label: "Annulé", color: "secondary", icon: <XCircle size={12} className="me-1" /> },
      canceled: { label: "Annulé", color: "secondary", icon: <XCircle size={12} className="me-1" /> },
    };
    const config = statusConfig[statut?.toLowerCase()] || {
      label: statut || "Inconnu", color: "secondary", icon: null,
    };
    return (
      <Badge bg={config.color} className="px-2 py-1 d-inline-flex align-items-center">
        {config.icon}
        {config.label}
      </Badge>
    );
  };

  const getPaymentMethodName = (methode) => {
    switch (methode?.toLowerCase()) {
      case "am": return "Airtel Money";
      case "card": return "Carte bancaire";
      case "cash": return "Espèces";
      case "bank": return "Virement";
      default: return methode || "Non spécifié";
    }
  };

  // ==================== CHARGEMENT DES DONNÉES ====================

  const loadFilterOptions = useCallback(async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/collectes/filter-options`, {
        headers: getHeaders(),
        params: { market_scope: effectiveMarketScope() },
      });
      if (response.data) {
        setFilterOptions({
          taxes: response.data.taxes || [],
          contribuables: response.data.contribuables || [],
        });
      }
    } catch (error) {
      console.error("Erreur chargement options filtres:", error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [marketScope, canUseMarketScope]);

  const loadStats = useCallback(async () => {
    try {
      setLoadingStats(true);
      const response = await axios.get(`${API_BASE_URL}/collectes/stats`, {
        headers: getHeaders(),
        params: { market_scope: effectiveMarketScope() },
      });
      if (response.data) {
        setStats(response.data);
      }
    } catch (error) {
      console.error("Erreur chargement stats:", error);
    } finally {
      setLoadingStats(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [marketScope, canUseMarketScope]);

  const loadCollectes = useCallback(
    async (page = 1) => {
      try {
        setLoading(true);
        setError(null);

        const params = {
          page,
          limit: pagination.per_page,
          search: filterText,
          sort_field: sortField,
          sort_direction: sortDirection,
          market_scope: effectiveMarketScope(),
          ...filters,
        };

        Object.keys(params).forEach((key) => {
          if (!params[key] && params[key] !== 0) delete params[key];
        });

        const response = await axios.get(`${API_BASE_URL}/collectes`, {
          headers: getHeaders(),
          params,
        });

        console.log("🔍 RÉPONSE BRUTE /collectes:", response.data);
console.log("🔍 Première ligne (data[0]):", JSON.stringify(response.data?.data?.[0], null, 2));

        if (response.data && response.data.success) {
          const paiementsWithActivite = await Promise.all(
            response.data.data.map(async (paiement) => {
              if (paiement.activite_id && !paiement.nom_activite) {
                try {
                  const activiteResponse = await axios.get(
                    `${API_BASE_URL}/activites/${paiement.activite_id}`,
                    { headers: getHeaders() }
                  );
                  if (activiteResponse.data) {
                    const activite = activiteResponse.data;
                    return {
                      ...paiement,
                      nom_activite:
                        activite.name || activite.nom || activite.libelle || paiement.activite_id,
                      activite: activite,
                    };
                  }
                } catch (error) {
                  console.error(`Erreur chargement activité ${paiement.activite_id}:`, error);
                  return { ...paiement, nom_activite: `Activité ${paiement.activite_id}` };
                }
              }
              return paiement;
            })
          );

          setPaiements(paiementsWithActivite);
          setPagination(response.data.pagination);
        } else {
          setPaiements([]);
        }
      } catch (error) {
        const errorMsg = error.response?.data?.message || error.message;
        setError(errorMsg);
        setPaiements([]);
        showAlert(errorMsg, "danger");
      } finally {
        setLoading(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [filterText, filters, sortField, sortDirection, pagination.per_page, marketScope, canUseMarketScope]
  );

  const loadEcheanceDetails = async (usagerId, taxeId, echeanceId) => {
    try {
      setLoadingEcheancesDetails(true);
      const response = await axios.get(`${API_BASE_URL}/terms`, {
        headers: getHeaders(),
        params: { usager_id: usagerId, taxe_id: taxeId },
      });

      if (response.data && response.data.code === 200 && Array.isArray(response.data.echeances)) {
        const echeance = response.data.echeances.find(
          (e) => e.echeance_id === echeanceId || (e.usager_id == usagerId && e.taxe_id == taxeId)
        );

        if (echeance) {
          const montantInitial = parseFloat(echeance.montant_initial || 0);
          const totalPaye = parseFloat(echeance.montant_paye || 0);
          setEcheanceDetails({
            montant_initial: montantInitial,
            total_paye: totalPaye,
            reste: montantInitial - totalPaye,
            pourcentage: montantInitial > 0 ? (totalPaye / montantInitial) * 100 : 0,
            date_echeance: echeance.date_echeance,
            statut: echeance.statut,
            periode:
              echeance.date_debut_periode && echeance.date_fin_periode
                ? `${formatDate(echeance.date_debut_periode)} - ${formatDate(echeance.date_fin_periode)}`
                : null,
          });
        }
      }
    } catch (error) {
      console.error("Erreur chargement détails échéance:", error);
    } finally {
      setLoadingEcheancesDetails(false);
    }
  };

  // ==================== FONCTIONS POUR LES LOCALITÉS ====================

  const fetchAllLocalites = async () => {
    try {
      const response = await axios.get(LOCALITES_ENDPOINT, { headers: getHeaders() });
      let localitesArray = [];
      if (response.data && Array.isArray(response.data)) localitesArray = response.data;
      else if (response.data && response.data.data && Array.isArray(response.data.data))
        localitesArray = response.data.data;
      setAllLocalites(localitesArray);
      return localitesArray;
    } catch (error) {
      console.error("Erreur chargement localités:", error);
      return [];
    }
  };

  const getParentChain = (localitesList, localiteId, chain = []) => {
    if (!localiteId) return chain;
    const current = localitesList.find((l) => l.localite_id === localiteId);
    if (!current) return chain;
    chain.unshift(current);
    if (current.parent_id) return getParentChain(localitesList, current.parent_id, chain);
    return chain;
  };

  const extractLocationInfoFromChain = (chain) => {
    let province = null, departement = null, ville = null, commune = null,
      arrondissement = null, quartier = null, pays = null, avenue = null,
      numero = null, code_fiscal = null;

    chain.forEach((loc) => {
      if (loc.pays_code && !pays) pays = loc.pays_code === "CD" ? "RDC" : loc.pays_code;
      switch (loc.type_code) {
        case 1005: if (!province) province = loc.nom; break;
        case 1004: if (!departement) departement = loc.nom; break;
        case 1001: if (!ville) ville = loc.nom; break;
        case 1000: if (!commune) commune = loc.nom; break;
        case 1003: if (!arrondissement) arrondissement = loc.nom; break;
        case 1002: if (!quartier) quartier = loc.nom; break;
        default: break;
      }
      if (loc.avenue) avenue = loc.avenue;
      if (loc.numero) numero = loc.numero;
      if (loc.code_fiscal) code_fiscal = loc.code_fiscal;
    });

    if (commune && !ville) ville = commune;

    const adresseParts = [];
    if (avenue) adresseParts.push(avenue);
    if (quartier) adresseParts.push(quartier);
    if (arrondissement) adresseParts.push(arrondissement);
    if (commune) adresseParts.push(commune);
    if (ville) adresseParts.push(ville);
    if (departement) adresseParts.push(departement);
    if (province) adresseParts.push(province);

    return {
      province, departement, ville, commune, arrondissement, quartier, avenue,
      numero, code_fiscal, pays: pays || "",
      adresseComplete: adresseParts.join(", "),
      chaineComplete: chain,
    };
  };

  const fetchContribuableLocalite = async (contribuableData) => {
    if (!contribuableData || !contribuableData.localite_id) {
      setLocaliteInfo({
        adresseComplete: contribuableData?.adresse || "",
        pays: "", commune: "", ville: "", quartier: "", avenue: "", numero: "", code_fiscal: "",
      });
      return;
    }

    setLoadingLocalite(true);
    try {
      let localitesData = allLocalites;
      if (localitesData.length === 0) localitesData = await fetchAllLocalites();

      const localiteId = contribuableData.localite_id;
      if (localiteId && localitesData.length > 0) {
        const foundLocalite = localitesData.find((l) => l.localite_id === localiteId);
        if (foundLocalite) {
          const chain = getParentChain(localitesData, localiteId, []);
          if (chain.length > 0) {
            setLocaliteInfo(extractLocationInfoFromChain(chain));
            return;
          }
        }
      }
      setLocaliteInfo({
        adresseComplete: contribuableData.adresse || "",
        pays: "", commune: "", ville: "", quartier: "", avenue: "", numero: "", code_fiscal: "",
      });
    } catch (error) {
      console.error("Erreur chargement localité:", error);
      setLocaliteInfo({ adresseComplete: contribuableData.adresse || "", pays: "" });
    } finally {
      setLoadingLocalite(false);
    }
  };

  // Chargement initial
  useEffect(() => {
    loadFilterOptions();
    loadStats();
    fetchAllLocalites();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Rechargement quand marketScope change
  useEffect(() => {
    if (canUseMarketScope) {
      loadFilterOptions();
      loadStats();
      loadCollectes(1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [marketScope]);

  // Rechargement quand les filtres/pagination changent
  useEffect(() => {
    loadCollectes(pagination.current_page);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.current_page, pagination.per_page, filterText, filters, sortField, sortDirection]);

  // ==================== GESTION DES FILTRES ====================

  const resetFilters = () => {
    setFilters({
      dateDebut: "", dateFin: "", statut: "", methode: "", taxeId: "",
      montantMin: "", montantMax: "", contribuableId: "",
    });
    setFilterText("");
    setPagination((prev) => ({ ...prev, current_page: 1 }));
    showAlert("Filtres réinitialisés", "info");
  };

  const handleSort = (field) => {
    if (sortField === field) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortField(field);
      setSortDirection("desc");
    }
    setPagination((prev) => ({ ...prev, current_page: 1 }));
  };

  const handlePageChange = (page) => {
    setPagination((prev) => ({ ...prev, current_page: page }));
  };

  // ==================== NOTE DE PERCEPTION ====================
// ==================== NOTE DE PERCEPTION ====================
const generateNotePerception = async (paiement) => {
  console.log("=== GÉNÉRATION DE LA NOTE DE PERCEPTION ===");

  let fullPaiement = paiement;

  try {
    const response = await axios.get(
      `${API_BASE_URL}/payments/${paiement.reference_paiement}`,
      {
        headers: getHeaders(),
        params: { market_scope: effectiveMarketScope() },
      }
    );

    if (response.data && response.data.code === 200 && response.data.paiement) {
      fullPaiement = {
        ...paiement,
        ...response.data.paiement,
        contribuable: response.data.paiement.contribuable || paiement.contribuable,
        taxe: response.data.paiement.taxe || paiement.taxe,
        activite: response.data.paiement.activite || paiement.activite,
        echeance: response.data.paiement.echeance || paiement.echeance,
      };
    }
  } catch (error) {
    console.error("❌ Erreur chargement données complètes:", error);
  }

  const contribuable = fullPaiement?.contribuable || {};
  const contribuableAdresse = contribuable.adresse || fullPaiement?.contribuable_adresse || "";
  const contribuableLocaliteId = contribuable.localite_id || fullPaiement?.localite_id;

  let communeNom = "";
  let adresseAffichage = contribuableAdresse || "";

  if (contribuableLocaliteId && allLocalites.length > 0) {
    try {
      const foundLocalite = allLocalites.find((l) => l.localite_id === contribuableLocaliteId);
      if (foundLocalite) {
        const chain = getParentChain(allLocalites, contribuableLocaliteId, []);
        const locationInfo = extractLocationInfoFromChain(chain);
        communeNom = locationInfo.commune || "";
      }
    } catch (error) {
      console.error("Erreur récupération localité:", error);
    }
  }

  // Numéro de document
  let documentInfo = { id_doc: null };
  try {
    const documentResponse = await axios.get(`${API_BASE_URL}/document`, { headers: getHeaders() });
    if (documentResponse.data && documentResponse.data.id_doc) {
      documentInfo.id_doc = documentResponse.data.id_doc;
    } else {
      documentInfo.id_doc = fullPaiement?.reference_paiement || `NP-${Date.now()}`;
    }
  } catch (error) {
    documentInfo.id_doc = fullPaiement?.reference_paiement || `NP-${Date.now()}`;
  }

  const receiptNumber = documentInfo.id_doc;
  const currentDate = new Date();

  // ✅ NOUVEAU : date réelle du paiement
  const datePaiement = fullPaiement?.date_paiement
    ? new Date(fullPaiement.date_paiement)
    : currentDate;

  const formatDateFr = (date) => {
    if (!date) return "";
    const d = new Date(date);
    if (isNaN(d.getTime())) return "";
    return d.toLocaleDateString("fr-FR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };
  const datePaiementAffichee = formatDateFr(datePaiement);

  const formatDateShortForFile = (date) => {
    if (!date) return "";
    const d = new Date(date);
    return `${String(d.getDate()).padStart(2, "0")}-${String(d.getMonth() + 1).padStart(2, "0")}-${d.getFullYear()}`;
  };

  const fileName = `NOTE_PERCEPTION_${receiptNumber}_${formatDateShortForFile(datePaiement)}`;
  const originalTitle = document.title;
  document.title = fileName;

  const formatDateShort = (date) => {
    if (!date) return "";
    const d = new Date(date);
    return d.toLocaleDateString("fr-FR", { day: "2-digit", month: "2-digit", year: "numeric" });
  };

  const formatCurrencyNP = (amount) => {
    const num = parseFloat(amount) || 0;
    return num.toLocaleString("fr-FR", { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + " FC";
  };

  const MOIS_FR = [
    "janvier", "février", "mars", "avril", "mai", "juin",
    "juillet", "août", "septembre", "octobre", "novembre", "décembre",
  ];

const formatMoisAnneeFr = (dateInput) => {
  if (!dateInput) return "";

  const s = String(dateInput).trim();

  // Cas 1 : déjà au format "d/m/Y" (ce que renvoie le backend)
  const matchDMY = s.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (matchDMY) {
    const [, jj, mm, aaaa] = matchDMY;
    const idx = parseInt(mm, 10) - 1;
    if (idx >= 0 && idx < 12) {
      return `${parseInt(jj, 10)} ${MOIS_FR[idx]} ${aaaa}`;
    }
  }

  // Cas 2 : date ISO "YYYY-MM-DD..." → "15 octobre 2026"
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) {
    const d = new Date(s);
    if (!isNaN(d.getTime())) {
      return `${d.getDate()} ${MOIS_FR[d.getMonth()]} ${d.getFullYear()}`;
    }
  }

  // Cas 3 : objet Date
  if (dateInput instanceof Date && !isNaN(dateInput.getTime())) {
    return `${dateInput.getDate()} ${MOIS_FR[dateInput.getMonth()]} ${dateInput.getFullYear()}`;
  }

  // Fallback : retourne tel quel
  return s;
};
  // ✅ Période = mois/année de l'échéance
  // ✅ Période = date d'échéance, formatée en "20 juillet 2026"
let periodeEcheance = "";

const dateEch =
  fullPaiement?.echeance?.date_echeance ||       // 1. priorité absolue
  fullPaiement?.echeance?.date_debut_periode ||  // 2. sinon début de période
  fullPaiement?.echeance_periode ||              // 3. sinon période backend
  fullPaiement?.period_label;                    // 4. fallback

if (dateEch) {
  // ✅ On passe la valeur BRUTE (string ou Date) — formatMoisAnneeFr gère les 2
  periodeEcheance = formatMoisAnneeFr(dateEch);
}

if (!periodeEcheance) periodeEcheance = "Période non spécifiée";

  const montantTransaction = parseFloat(fullPaiement?.montant || 0);

  const agentTaxateurNom = "Franck KASONGO";
  const agentTaxateurQualite = "Chef de Service Économie";
  const ordonnateurNom = "NHUNGA MAKENGO Jacqueline";
  const comptableNom = "META KABAMBA Mimie";

  const taxeLibelle =
    fullPaiement?.taxe_titre ||
    fullPaiement?.taxe?.titre ||
    fullPaiement?.taxe?.nom ||
    "Taxe professionnelle";

  const nomContribuable =
    fullPaiement?.nom_contribuable ||
    fullPaiement?.contribuable?.nom_contribuable ||
    "__________________";

  const montantEnLettres = convertirMontantEnLettres(montantTransaction);

  const getPaymentMethodLabel = () => {
    const methods = {
      cash: "Espèces",
      credit_card: "Carte Bancaire",
      mobile_money: "Mobile Money",
      check: "Chèque",
      bank_transfer: "Virement bancaire",
      AM: "Airtel Money",
      card: "Carte bancaire",
      bank: "Virement",
    };
    return methods[fullPaiement?.methode?.toLowerCase()] || fullPaiement?.methode || "Espèces";
  };

  const bordereauNumber = fullPaiement?.reference_paiement || `TX${Date.now()}`;

  let qrCodeBase64 = "";
  try {
    const qrResponse = await axios.post(
      `${API_BASE_URL}/qrcode`,
      { payment_id: String(fullPaiement.reference_paiement || receiptNumber) },
      { headers: getHeaders() }
    );
    if (qrResponse.data && qrResponse.data.rid) {
      qrCodeBase64 = await QRCode.toDataURL(qrResponse.data.rid, {
        width: 80,
        margin: 1,
        color: { dark: "#000000", light: "#ffffff" },
      });
    }
  } catch (error) {
    console.error("❌ Erreur QR Code:", error);
  }

  const htmlContent = `<!DOCTYPE html>
<html lang="fr">
<head>
<meta charset="UTF-8">
<title>${fileName}</title>
<style>
  @page { size: A4 portrait; margin: 0; }
  * { margin: 0; padding: 0; box-sizing: border-box; }
  html, body {
    width: 210mm; height: 297mm; margin: 0; padding: 0;
    background: #fff;
    font-family: 'Arial', 'Helvetica', sans-serif;
    font-size: 9pt; color: #000; line-height: 1.25; overflow: hidden;
  }
  .page {
    width: 100%; height: 297mm;
    padding: 30mm 12mm 8mm 12mm;
    display: flex; flex-direction: column; box-sizing: border-box;
  }
  .main-title {
    text-align: center; font-size: 12pt; font-weight: bold;
    text-transform: uppercase; letter-spacing: 0.8px;
    margin-bottom: 4pt; padding-bottom: 3pt;
    border-bottom: 1.5px solid #000;
  }
  .doc-header {
    display: flex; justify-content: space-between; align-items: center;
    font-size: 9pt; margin-bottom: 4pt; padding-bottom: 2pt;
  }
  .doc-header .label { font-weight: bold; font-size: 10pt; }
  .doc-header .date { font-size: 8.5pt; }
  .section { border: 1.1px solid #000; margin-bottom: 5pt; }
  .section-title {
    background: #d9d9d9; font-weight: bold; font-size: 9.5pt;
    padding: 2.5pt 6pt; border-bottom: 1.1px solid #000;
    text-transform: uppercase;
  }
  .section-content { padding: 3pt 6pt; }
  .field-line {
    display: flex; align-items: baseline; padding: 1.5pt 0;
    border-bottom: 1px dotted #999; font-size: 8.5pt;
  }
  .field-line:last-child { border-bottom: none; }
  .field-label {
    font-weight: bold; min-width: 120pt; padding-right: 6pt; flex-shrink: 0;
  }
  .field-value { flex: 1; font-weight: normal; min-height: 11pt; }
  .field-value.bold { font-weight: bold; }
  .field-value.amount { font-weight: bold; text-align: left; }
  .field-line.two-col {
    display: grid; grid-template-columns: 1fr 1fr; gap: 10pt; align-items: start;
  }
  .field-line.two-col .field-label { min-width: auto; }
  .field-line.two-col > div { display: flex; flex-direction: column; }
  .id-grid { display: grid; grid-template-columns: 1fr 1fr; }
  .id-grid .field-line {
    border-bottom: 1px dotted #999; padding: 2pt 5pt; font-size: 8.5pt;
  }
  .id-grid .field-line:nth-child(odd) { border-right: 1px solid #000; }
  .id-grid .field-line:nth-last-child(-n+2) { border-bottom: none; }
  .id-grid .field-label { min-width: 80pt; }
  .payment-options {
    display: flex; flex-direction: column; gap: 1.5pt; margin-top: 2pt;
  }
  .payment-option { display: flex; align-items: baseline; font-size: 8.5pt; }
  .payment-option .checkbox {
    display: inline-block; width: 9pt; height: 9pt; border: 1px solid #000;
    margin-right: 5pt; text-align: center; line-height: 8pt;
    font-size: 8pt; font-weight: bold; flex-shrink: 0;
  }
  .payment-option .option-label { font-weight: normal; margin-right: 4pt; }
  .payment-option .option-value {
    font-weight: bold; border-bottom: 1px dotted #999; flex: 1;
    padding-bottom: 1pt; min-height: 10pt;
  }
  .signature-zone { position: relative; min-height: 28pt; }
  .footer-row {
    display: flex; justify-content: space-between; align-items: flex-end;
    margin-top: auto; padding-top: 6pt;
  }
  .signature-contribuable { flex: 1; text-align: center; padding-right: 20pt; }
  .signature-contribuable .sig-line {
    width: 160pt; height: 1.2px; background: #000; margin: 0 auto 4pt auto;
  }
  .signature-contribuable .sig-label {
    font-size: 9pt; font-weight: bold; text-transform: uppercase;
  }
  .qr-zone { width: 70px; text-align: center; }
  .qr-zone img {
    width: 60px; height: 60px; border: 1px solid #ddd; padding: 2px; background: #fff;
  }
  .qr-zone .qr-label { font-size: 6pt; color: #666; margin-top: 1pt; }
</style>
</head>
<body>
<div class="page">

  <div class="main-title">Note de perception</div>

  <div class="doc-header">
    <div><span class="label">N° ${receiptNumber}</span></div>
    <div class="date">Du ${datePaiementAffichee}</div>
  </div>

   <!-- IDENTIFICATION DU CONTRIBUABLE -->
  <div class="section">
    <div class="section-title">Identification du contribuable</div>
    <div class="id-grid">
      <div class="field-line">
        <span class="field-label">Nom ou Raison Sociale :</span>
        <span class="field-value bold">${nomContribuable}</span>
      </div>
      <div class="field-line">
        <span class="field-label">Post-noms ou prénoms :</span>
        <span class="field-value">${fullPaiement?.contribuable?.prenoms || ""}</span>
      </div>
      <div class="field-line">
        <span class="field-label">Adresse :</span>
        <span class="field-value">${adresseAffichage || ""}</span>
      </div>
      <div class="field-line">
        <span class="field-label">Commune :</span>
        <span class="field-value">${communeNom || ""}</span>
      </div>
      <div class="field-line">
        <span class="field-label">B.P :</span>
        <span class="field-value">${fullPaiement?.contribuable?.boite_postale || ""}</span>
      </div>
      <div class="field-line">
        <span class="field-label">Tél. :</span>
        <span class="field-value">${fullPaiement?.client_phone || fullPaiement?.contribuable?.telephone || ""}</span>
      </div>
    </div>
  </div>


  <!-- SECTION 1 : SERVICE TAXATEUR -->
  <div class="section">
    <div class="section-title">1. - A REMPLIR PAR LE SERVICE TAXATEUR</div>
    <div class="section-content">

      <div class="field-line">
        <span class="field-label">Acte générateur (libellé) :</span>
        <span class="field-value bold">${taxeLibelle}</span>
      </div>

      <div class="field-line">
        <span class="field-label">Article budgétaire (libellé) :</span>
        <span class="field-value">${periodeEcheance}</span>
      </div>

      <div class="field-line two-col">
        <div>
          <span class="field-label">Montant à payer</span>
          <span class="field-value amount">- en chiffres : ${formatCurrencyNP(montantTransaction)}</span>
        </div>
        <div>
          <span class="field-label">- en lettres :</span>
          <span class="field-value" style="font-size:8pt; line-height:1.2;">${montantEnLettres}</span>
        </div>
      </div>

      <div class="field-line">
        <span class="field-label">Nom de l'Agent Taxateur :</span>
        <span class="field-value bold">${agentTaxateurNom}</span>
      </div>

      <div class="field-line">
        <span class="field-label">Qualité :</span>
        <span class="field-value">${agentTaxateurQualite}</span>
      </div>

      <div class="field-line">
        <span class="field-label">Signature et Sceau :</span>
        <span class="field-value signature-zone"></span>
      </div>

    </div>
  </div>

 
  <!-- SECTION 2 : SERVICE ORDONNATEUR -->
  <div class="section">
    <div class="section-title">2. - A REMPLIR PAR LE SERVICE ORDONNATEUR</div>
    <div class="section-content">

      <!-- ✅ Date de réception = date du paiement -->
      <div class="field-line">
        <span class="field-label">Date de réception :</span>
        <span class="field-value">${datePaiementAffichee}</span>
      </div>

      <div class="field-line">
        <span class="field-label">Avis motivé de l'Ordonnateur :</span>
        <span class="field-value bold">Conforme</span>
      </div>

      <div class="field-line">
        <span class="field-label">Délai de paiement au plus tard le :</span>
        <span class="field-value"></span>
      </div>

      <div class="field-line">
        <span class="field-label">sous peine de pénalités de 100%</span>
        <span class="field-value"></span>
      </div>

      <div class="field-line two-col">
        <div>
          <span class="field-label">Montant visé</span>
          <span class="field-value amount">- en chiffres : ${formatCurrencyNP(montantTransaction)}</span>
        </div>
        <div>
          <span class="field-label">- en lettres :</span>
          <span class="field-value" style="font-size:8pt; line-height:1.2;">${montantEnLettres}</span>
        </div>
      </div>

      <div class="field-line">
        <span class="field-label">Nom et Signature de l'Ordonnateur :</span>
        <span class="field-value bold">${ordonnateurNom}</span>
      </div>

      <div class="field-line">
        <span class="field-label">Code du Centre d'Ordonnancement :</span>
        <span class="field-value"></span>
      </div>

    </div>
  </div>

  <!-- SECTION 3 : COMPTABLE -->
  <div class="section">
    <div class="section-title">3. - A REMPLIR PAR LE COMPTABLE</div>
    <div class="section-content">

      <div class="field-line">
        <span class="field-label">Code et désignation du bureau comptable :</span>
        <span class="field-value"></span>
      </div>

      <div class="field-line">
        <span class="field-label">Montant encaissé (en lettres) :</span>
        <span class="field-value" style="font-size:8pt; line-height:1.2;">${montantEnLettres}</span>
      </div>

      <div class="field-line">
        <span class="field-label">Mode de paiement :</span>
        <span class="field-value bold">${getPaymentMethodLabel()}</span>
      </div>

      <div class="payment-options">
        <div class="payment-option">
          <span class="checkbox">${getPaymentMethodLabel() === "Espèces" ? "X" : ""}</span>
          <span class="option-label">a) Espèces :</span>
          <span class="option-value">${getPaymentMethodLabel() === "Espèces" ? formatCurrencyNP(montantTransaction) : ""}</span>
        </div>
        <div class="payment-option">
          <span class="checkbox"></span>
          <span class="option-label">b) Chèque bancaire n°</span>
          <span class="option-value"></span>
          <span class="option-label" style="margin-left:6pt;">du</span>
          <span class="option-value" style="max-width:100pt;"></span>
        </div>
        <div class="payment-option">
          <span class="checkbox"></span>
          <span class="option-label">c) Chèque postal n°</span>
          <span class="option-value"></span>
          <span class="option-label" style="margin-left:6pt;">du</span>
          <span class="option-value" style="max-width:100pt;"></span>
        </div>

        <!-- ✅ Bordereau daté avec la date du paiement -->
        <div class="payment-option">
          <span class="checkbox"></span>
          <span class="option-label">d) Bordereau de versement n°</span>
          <span class="option-value">${bordereauNumber}</span>
          <span class="option-label" style="margin-left:6pt;">du</span>
          <span class="option-value" style="max-width:100pt;">${datePaiementAffichee}</span>
        </div>
      </div>

      <div class="field-line" style="margin-top:3pt;">
        <span class="field-label">Numéro de la quittance :</span>
        <span class="field-value bold">${receiptNumber}</span>
      </div>

      <!-- ✅ Date de perception = date réelle du paiement -->
      <div class="field-line">
        <span class="field-label">Date de la perception :</span>
        <span class="field-value">${datePaiementAffichee}</span>
      </div>

      <div class="field-line">
        <span class="field-label">Nom du comptable :</span>
        <span class="field-value bold">${comptableNom}</span>
      </div>

      <div class="field-line">
        <span class="field-label">Signature :</span>
        <span class="field-value signature-zone"></span>
      </div>

    </div>
  </div>

  <!-- Footer : signature contribuable + QR -->
  <div class="footer-row">
    <div class="signature-contribuable">
      <div class="sig-line"></div>
      <div class="sig-label">Signature du contribuable</div>
    </div>
    ${qrCodeBase64 ? `
    <div class="qr-zone">
      <img src="${qrCodeBase64}" alt="QR" />
      <div class="qr-label">Vérification</div>
    </div>
    ` : ""}
  </div>

</div>
</body>
</html>`;

  const iframe = document.createElement("iframe");
  iframe.style.position = "absolute";
  iframe.style.width = "0";
  iframe.style.height = "0";
  iframe.style.border = "none";
  document.body.appendChild(iframe);
  const iframeDoc = iframe.contentWindow.document;
  iframeDoc.open();
  iframeDoc.write(htmlContent);
  iframeDoc.close();
  iframe.contentWindow.onload = () => {
    iframe.contentWindow.document.title = fileName;
    iframe.contentWindow.print();
    setTimeout(() => {
      document.title = originalTitle;
      if (document.body.contains(iframe)) document.body.removeChild(iframe);
      setPrintingPaymentId(null);
    }, 1500);
  };
};
// ==================== FIN NOTE DE PERCEPTION ====================

  // ========== CONVERSION MONTANTS EN LETTRES ==========
  const convertirMontantEnLettres = (montant) => {
    if (montant === 0) return "Zéro";
    const nombre = Math.floor(montant);
    if (nombre < 0) return "Moins " + convertirMontantEnLettres(-nombre);
    if (nombre > 999999999) return "Nombre trop grand";

    const unite = ["", "un", "deux", "trois", "quatre", "cinq", "six", "sept", "huit", "neuf",
      "dix", "onze", "douze", "treize", "quatorze", "quinze", "seize",
      "dix-sept", "dix-huit", "dix-neuf"];
    const dizaine = ["", "", "vingt", "trente", "quarante", "cinquante",
      "soixante", "soixante-dix", "quatre-vingt", "quatre-vingt-dix"];

    const convertToWords = (n) => {
      if (n < 20) return unite[n];
      if (n < 100) {
        const d = Math.floor(n / 10);
        const u = n % 10;
        if (d === 7 || d === 9) {
          const base = d === 7 ? "soixante-" : "quatre-vingt-";
          if (u === 0) return d === 7 ? "soixante-dix" : "quatre-vingts";
          if (u === 1) return base + "onze";
          return base + unite[10 + u];
        }
        let result = dizaine[d];
        if (u === 0) return result;
        if (u === 1 && d !== 8) return result + "-et-un";
        if (d === 8 && u === 1) return result + "-un";
        return result + "-" + unite[u];
      }
      if (n < 1000) {
        const c = Math.floor(n / 100);
        const r = n % 100;
        let result = "";
        if (c === 1) result = "cent";
        else result = unite[c] + "-cent";
        if (r === 0) {
          if (c > 1) result = unite[c] + "-cents";
          return result;
        }
        if (c > 1 && r < 10) result = unite[c] + "-cent";
        return result + "-" + convertToWords(r);
      }
      return "";
    };

    const convertThousands = (n) => {
      if (n === 0) return "";
      const milliers = Math.floor(n / 1000);
      const reste = n % 1000;
      let result = milliers === 1 ? "mille" : convertToWords(milliers) + "-mille";
      if (reste > 0) result += "-" + convertToWords(reste);
      return result;
    };

    let result = "";
    if (nombre >= 1000000) {
      const millions = Math.floor(nombre / 1000000);
      const reste = nombre % 1000000;
      result = millions === 1 ? "un-million" : convertToWords(millions) + "-millions";
      if (reste > 0) {
        result += "-" + (reste < 1000 ? convertToWords(reste) : convertThousands(reste));
      }
    } else if (nombre >= 1000) {
      result = convertThousands(nombre);
    } else {
      result = convertToWords(nombre);
    }

    result = result.replace(/--/g, "-").replace(/^-/, "").replace(/-$/, "");
    return result.charAt(0).toUpperCase() + result.slice(1) + " Francs Congolais";
  };

  // ==================== ANNULATION PAIEMENT ====================
  const handleCancelPayment = async () => {
    if (!cancelReason.trim()) {
      setCancelReasonError("Veuillez fournir une raison pour l'annulation");
      return;
    }
    if (!paymentToCancel || !paymentToCancel.reference_paiement) {
      showAlert("Paiement invalide", "danger");
      return;
    }

    setCancellingPayment(true);
    try {
      const response = await axios.delete(
        `${API_BASE_URL}/payments/${paymentToCancel.reference_paiement}`,
        {
          headers: getHeaders(),
          data: { reason_cancellation: cancelReason, market_scope: effectiveMarketScope() },
        }
      );

      if (response.data && (response.data.code === 200 || response.data.success)) {
        showAlert("Paiement annulé avec succès", "success");
        setShowCancelConfirmModal(false);
        setShowDetailsModal(false);
        setSelectedPaiement(null);
        setPaymentToCancel(null);
        setCancelReason("");
        setCancelReasonError("");
        await loadStats();
        await loadCollectes(pagination.current_page);
      } else {
        showAlert(response.data?.message || "Erreur lors de l'annulation", "danger");
      }
    } catch (error) {
      console.error("Erreur annulation paiement:", error);
      showAlert(error.response?.data?.message || "Erreur lors de l'annulation du paiement", "danger");
    } finally {
      setCancellingPayment(false);
    }
  };

  const generateQRCodeFromAPI = async (paymentId, reference = null) => {
    try {
      const payload = { payment_id: String(paymentId) };
      if (reference) payload.reference = reference;
      const response = await axios.post(`${API_BASE_URL}/qrcode`, payload, { headers: getHeaders() });
      if (response.data) {
        let rid = response.data.rid || response.data.data?.rid;
        if (rid) {
          const qrCodeBase64 = await QRCode.toDataURL(rid, {
            width: 120, margin: 1, color: { dark: "#1a3c5e", light: "#ffffff" },
          });
          return { qrCodeBase64, rid };
        }
      }
      return null;
    } catch (error) {
      console.error("Erreur génération QR Code:", error);
      return null;
    }
  };

  // ==================== GÉNÉRATION BORDEREAU (QUITTANCE) ====================
  const generateBordereauPaiement = async (paiement) => {
    if (!paiement) {
      alert("Impossible de générer le document : données de paiement manquantes");
      return;
    }

    let fullPaiement = paiement;
    try {
      const response = await axios.get(
        `${API_BASE_URL}/payments/${paiement.reference_paiement}`,
        {
          headers: getHeaders(),
          params: { market_scope: effectiveMarketScope() },
        }
      );
      if (response.data && response.data.code === 200 && response.data.paiement) {
        fullPaiement = {
          ...paiement,
          ...response.data.paiement,
          contribuable: response.data.paiement.contribuable || paiement.contribuable,
          taxe: response.data.paiement.taxe || paiement.taxe,
          activite: response.data.paiement.activite || paiement.activite || response.data.activite,
          echeance: response.data.paiement.echeance || paiement.echeance,
          agent: response.data.paiement.agent || paiement.agent,
          nom_activite:
            response.data.paiement.activite?.name ||
            response.data.paiement.activite?.nom ||
            response.data.activite?.name ||
            response.data.activite?.nom ||
            paiement.nom_activite ||
            "Activité non spécifiée",
        };
      }
    } catch (error) {
      console.error("❌ Erreur chargement données complètes:", error);
    }

    setPrintingPaymentId(paiement.id);

    const receiptNumber = fullPaiement?.reference_paiement || `RCP-${Date.now()}`;
    const currentDate = new Date();
    const formatDateShortBordereau = (date) => {
      if (!date) return "";
      const d = new Date(date);
      return `${String(d.getDate()).padStart(2, "0")}-${String(d.getMonth() + 1).padStart(2, "0")}-${d.getFullYear()}`;
    };
    const fileName = `QUITTANCE_${receiptNumber}_${formatDateShortBordereau(currentDate)}`;
    const originalTitle = document.title;
    document.title = fileName;

    const contribuableNom =
      fullPaiement?.contribuable?.nom_contribuable ||
      fullPaiement?.nom_contribuable ||
      fullPaiement?.usager_nom ||
      "Non spécifié";
    const contribuableId = fullPaiement?.usager_id || fullPaiement?.contribuable?.usager_id || "N/A";
    const telephone =
      fullPaiement?.client_phone ||
      fullPaiement?.contribuable?.telephone ||
      fullPaiement?.contribuable?.phone ||
      "Non spécifié";
    const taxeTitre =
      fullPaiement?.taxe?.titre ||
      fullPaiement?.taxe_titre ||
      fullPaiement?.titre_taxe ||
      fullPaiement?.taxe_nom ||
      fullPaiement?.taxe?.nom ||
      "Taxe non spécifiée";
    const activiteNom =
      fullPaiement?.activite?.name ||
      fullPaiement?.activite?.nom ||
      fullPaiement?.nom_activite ||
      fullPaiement?.activite_nom ||
      fullPaiement?.activite?.category_name ||
      fullPaiement?.type_activite ||
      fullPaiement?.activite_contribuable ||
      fullPaiement?.contribuable?.activite?.name ||
      fullPaiement?.contribuable?.activite?.nom ||
      fullPaiement?.contribuable?.activite_contribuable ||
      fullPaiement?.taxe?.activite?.name ||
      "";

    let adresseComplete =
      fullPaiement?.contribuable?.adresse ||
      fullPaiement?.adresse ||
      fullPaiement?.contribuable_adresse ||
      "";
    const localiteId = fullPaiement?.contribuable?.localite_id || fullPaiement?.localite_id;
    if (localiteId && allLocalites.length > 0) {
      try {
        const foundLocalite = allLocalites.find((l) => l.localite_id === localiteId);
        if (foundLocalite) {
          const chain = getParentChain(allLocalites, localiteId, []);
          if (chain.length > 0) {
            const locationInfo = extractLocationInfoFromChain(chain);
            if (locationInfo.adresseComplete && locationInfo.adresseComplete !== "") {
              adresseComplete = locationInfo.adresseComplete;
            }
          }
        }
      } catch (error) {
        console.error("Erreur récupération localité:", error);
      }
    }

    const periodLabel = fullPaiement?.echeance?.date_echeance
      ? new Date(fullPaiement.echeance.date_echeance).toLocaleDateString("fr-FR", {
          month: "long",
          year: "numeric",
        })
      : fullPaiement?.echeance_periode || fullPaiement?.period_label || "Période non spécifiée";

    const montantTransaction = parseFloat(fullPaiement?.montant || 0);
    const montantInitialEcheance = parseFloat(
      fullPaiement?.echeance?.montant_initial ||
        fullPaiement?.echeance?.montant_attendu ||
        fullPaiement?.montant_attendu ||
        fullPaiement?.echeance_montant_initial ||
        montantTransaction
    );
    const totalPayeEcheance = parseFloat(
      fullPaiement?.echeance?.montant_paye ||
        fullPaiement?.total_paye_echeance ||
        fullPaiement?.echeance_montant_paye ||
        montantTransaction
    );
    const montantRestantEcheance = Math.max(0, montantInitialEcheance - totalPayeEcheance);
    const montantPayeAvant = Math.max(0, totalPayeEcheance - montantTransaction);
    const agentNom =
      fullPaiement?.agent?.admin_fname ||
      fullPaiement?.admin_fname ||
      fullPaiement?.agent_nom ||
      "Agent non spécifié";

    const getPaymentMethodLabelLocal = () => {
      const methods = {
        cash: "Espèces", credit_card: "Carte Bancaire", mobile_money: "Mobile Money",
        check: "Chèque", bank_transfer: "Virement bancaire", AM: "Airtel Money",
        card: "Carte bancaire", bank: "Virement",
      };
      return methods[fullPaiement?.methode?.toLowerCase()] || fullPaiement?.methode || "Autre";
    };

    let qrCodeBase64 = "";
    try {
      const qrResponse = await axios.post(
        `${API_BASE_URL}/qrcode`,
        { payment_id: String(receiptNumber) },
        { headers: getHeaders() }
      );
      if (qrResponse.data && qrResponse.data.rid) {
        qrCodeBase64 = await QRCode.toDataURL(qrResponse.data.rid, {
          width: 100, margin: 1, color: { dark: "#1a3c5e", light: "#ffffff" },
        });
      }
    } catch (error) {
      console.error("Erreur génération QR Code:", error);
    }

    const formatCurrencyBordereau = (amount) => {
      const num = parseFloat(amount) || 0;
      return (
        num.toLocaleString("fr-FR", { minimumFractionDigits: 0, maximumFractionDigits: 0 }) +
        " " +
        defaultCurrency
      );
    };
    const formatDateBordereau = (date) => {
      if (!date) return "";
      const d = new Date(date);
      return d.toLocaleDateString("fr-FR", { day: "2-digit", month: "2-digit", year: "numeric" });
    };

    const htmlContent = `<!DOCTYPE html><html><head><meta charset="UTF-8"><title>${fileName}</title>
<style>
@page { size:A4 portrait; margin:12mm 15mm; }
html, body { width:210mm; height:297mm; margin:0; padding:0; background:white; font-family:'Segoe UI',Arial,sans-serif; font-size:10pt; color:#2c3e50; line-height:1.5; }
.receipt { width:100%; height:100%; display:flex; flex-direction:column; justify-content:space-between; }
.header { border-bottom:3px solid #1a3c5e; padding-bottom:10px; margin-bottom:12px; }
.header-top { display:flex; justify-content:space-between; align-items:center; margin-bottom:6px; }
.header-title { font-size:18pt; font-weight:bold; color:#1a3c5e; }
.header-subtitle { font-size:9pt; color:#6c757d; margin-top:2px; }
.document-number { font-size:11pt; font-weight:bold; color:#1a3c5e; text-align:right; }
.document-number .label { font-size:7pt; text-transform:uppercase; color:#6c757d; display:block; }
.qrcode-image { width:55px; height:55px; border:1px solid #dee2e6; border-radius:4px; padding:3px; }
.receipt-meta { display:flex; justify-content:space-between; margin-top:8px; padding-top:8px; border-top:1px dashed #dee2e6; }
.meta-item { text-align:center; flex:1; }
.meta-label { font-size:7pt; text-transform:uppercase; color:#6c757d; }
.meta-value { font-size:10pt; font-weight:bold; color:#1a3c5e; margin-top:2px; }
.meta-value.status-partial { color:#dc3545; }
.meta-value.status-paid { color:#28a745; }
.title { text-align:center; margin:10px 0 14px 0; }
.title h2 { font-size:16pt; color:#28a745; text-transform:uppercase; letter-spacing:2px; }
.sections { display:flex; gap:25px; margin-bottom:14px; }
.section { flex:1; }
.section-title { font-size:9pt; font-weight:bold; color:#1a3c5e; text-transform:uppercase; border-bottom:2px solid #1a3c5e; padding-bottom:5px; margin-bottom:8px; }
.info-line { margin-bottom:4px; font-size:10pt; display:flex; padding:2px 0; }
.info-label { color:#6c757d; min-width:85px; font-size:9pt; }
.info-value { color:#2c3e50; font-weight:500; word-break:break-word; }
.amount-table { background:#f8f9fa; padding:14px 18px; margin:8px 0 16px 0; border-radius:6px; border:1px solid #e9ecef; }
.amount-row { display:flex; justify-content:space-between; padding:5px 0; font-size:10pt; }
.amount-row.border-bottom { border-bottom:1px solid #dee2e6; padding-bottom:6px; margin-bottom:4px; }
.amount-row.highlight { background:#d4edda; margin:5px -14px; padding:6px 14px; border-radius:4px; }
.amount-row.highlight .amount-value { font-weight:bold; color:#28a745; font-size:11pt; }
.amount-row.total { margin-top:4px; padding-top:8px; border-top:2px solid #1a3c5e; font-size:11pt; font-weight:bold; }
.amount-row.total .amount-value { font-size:12pt; color:#28a745; }
.amount-row .amount-value.restant { color:#dc3545; font-weight:bold; }
.amount-row .amount-value.zero { color:#28a745; }
.signature-row { display:flex; justify-content:space-between; margin-top:20px; padding-top:14px; border-top:1.5px solid #dee2e6; }
.signature-col { width:45%; text-align:center; }
.sig-line { width:160px; height:1.5px; background:#333; margin:0 auto 4px auto; }
.sig-fonction { font-size:9pt; font-weight:600; color:#555; }
.sig-nom { font-size:8pt; color:#666; font-style:italic; }
.footer-bottom { margin-top:12px; padding-top:10px; border-top:1px solid #e9ecef; font-size:7pt; color:#adb5bd; display:flex; justify-content:space-between; }
</style></head><body>
<div class="receipt">
  <div class="header">
    <div class="header-top">
      <div><div class="header-title">SYNCTAXE</div><div class="header-subtitle">Plateforme de gestion fiscale</div></div>
      <div style="display:flex; align-items:center; gap:15px;">
        <div class="document-number"><span class="label">Quittance N°</span>${receiptNumber}</div>
        ${qrCodeBase64 ? `<div><img src="${qrCodeBase64}" alt="QR" class="qrcode-image" /><div style="font-size:6pt;color:#6c757d;text-align:center;">Vérification</div></div>` : ""}
      </div>
    </div>
    <div class="receipt-meta">
      <div class="meta-item"><div class="meta-label">Date d'émission</div><div class="meta-value">${formatDateBordereau(currentDate)}</div></div>
      <div class="meta-item"><div class="meta-label">Méthode</div><div class="meta-value">${getPaymentMethodLabelLocal()}</div></div>
      <div class="meta-item"><div class="meta-label">Statut</div><div class="meta-value ${montantRestantEcheance > 0 ? "status-partial" : "status-paid"}">${montantRestantEcheance > 0 ? "PAIEMENT PARTIEL" : "PAYÉ INTÉGRALEMENT"}</div></div>
    </div>
  </div>
  <div class="title"><h2>QUITTANCE DE PAIEMENT</h2></div>
  <div class="sections">
    <div class="section">
      <div class="section-title">Contribuable</div>
      <div class="info-line"><span class="info-label">Nom complet</span><span class="info-value">${contribuableNom}</span></div>
      <div class="info-line"><span class="info-label">Identifiant</span><span class="info-value">${contribuableId}</span></div>
      <div class="info-line"><span class="info-label">Téléphone</span><span class="info-value">${telephone}</span></div>
      <div class="info-line"><span class="info-label">Adresse</span><span class="info-value">${adresseComplete}</span></div>
    </div>
    <div class="section">
      <div class="section-title">Taxe et activité</div>
      <div class="info-line"><span class="info-label">Désignation</span><span class="info-value">${taxeTitre}</span></div>
      <div class="info-line"><span class="info-label">Activité</span><span class="info-value">${activiteNom}</span></div>
      <div class="info-line"><span class="info-label">Période</span><span class="info-value">${periodLabel}</span></div>
      <div class="info-line"><span class="info-label">Agent</span><span class="info-value">${agentNom}</span></div>
    </div>
  </div>
  <div class="amount-table">
    <div class="amount-row border-bottom"><span class="amount-label">Montant total de l'échéance</span><span class="amount-value">${formatCurrencyBordereau(montantInitialEcheance)}</span></div>
    <div class="amount-row border-bottom"><span class="amount-label">Déjà payé (antérieur)</span><span class="amount-value">${formatCurrencyBordereau(montantPayeAvant)}</span></div>
    <div class="amount-row highlight"><span class="amount-label">Montant payé (cette transaction)</span><span class="amount-value">${formatCurrencyBordereau(montantTransaction)}</span></div>
    <div class="amount-row total"><span class="amount-label">TOTAL PAYÉ À CE JOUR</span><span class="amount-value">${formatCurrencyBordereau(totalPayeEcheance)}</span></div>
    <div class="amount-row"><span class="amount-label">RESTE À PAYER</span><span class="amount-value ${montantRestantEcheance > 0 ? "restant" : "zero"}">${formatCurrencyBordereau(montantRestantEcheance)}</span></div>
  </div>
  <div class="signature-row">
    <div class="signature-col"><div class="sig-line"></div><div class="sig-fonction">LE CONTRIBUABLE</div><div class="sig-nom">${contribuableNom}</div></div>
    <div class="signature-col"><div class="sig-line"></div><div class="sig-fonction">LE COMPTABLE / AGENT</div><div class="sig-nom">META KABAMBA Mimie</div></div>
  </div>
  <div class="footer-bottom">
    <div>Généré le ${new Date().toLocaleString("fr-FR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" })}</div>
    <div>${defaultCurrency} • SyncTaxe</div>
  </div>
</div>
</body></html>`;

    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "none";
    document.body.appendChild(iframe);
    const iframeDoc = iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(htmlContent);
    iframeDoc.close();
    iframe.contentWindow.onload = () => {
      iframe.contentWindow.document.title = fileName;
      iframe.contentWindow.print({ printBackground: true, shrinkToFit: true });
      setTimeout(() => {
        document.title = originalTitle;
        if (document.body.contains(iframe)) document.body.removeChild(iframe);
        setPrintingPaymentId(null);
      }, 1500);
    };
  };

  // ==================== EXPORT ====================
  const handleExportCSV = async () => {
    try {
      setLoadingExport(true);
      const params = {
        limit: 10000,
        search: filterText,
        sort_field: sortField,
        sort_direction: sortDirection,
        market_scope: effectiveMarketScope(),
        ...filters,
      };
      Object.keys(params).forEach((key) => {
        if (!params[key] && params[key] !== 0) delete params[key];
      });
      const response = await axios.get(`${API_BASE_URL}/collectes`, {
        headers: getHeaders(),
        params,
      });
      const dataToExport = response.data.data || [];
      const exportData = dataToExport.map((item) => ({
        Référence: item.reference_paiement,
        Date: formatDate(item.date_paiement),
        Contribuable: item.nom_contribuable,
        "ID Contribuable": item.usager_id,
        Taxe: item.taxe_titre,
        Montant: item.montant,
        Statut: item.statut,
        Méthode: getPaymentMethodName(item.methode),
        Téléphone: item.client_phone,
      }));
      const columns = Object.keys(exportData[0] || {});
      const csvRows = [columns.join(";")];
      for (const row of exportData) {
        const values = columns.map((col) => `"${String(row[col] || "").replace(/"/g, '""')}"`);
        csvRows.push(values.join(";"));
      }
      const blob = new Blob(["\uFEFF" + csvRows.join("\n")], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `collectes_${new Date().toISOString().split("T")[0]}.csv`;
      a.click();
      URL.revokeObjectURL(url);
      showAlert("Export CSV terminé avec succès", "success");
    } catch (error) {
      showAlert(`Erreur lors de l'export: ${error.message}`, "danger");
    } finally {
      setLoadingExport(false);
    }
  };

  // ==================== DÉTAILS CONTRIBUABLE ====================
  const fetchContribuableTaxes = async (contribuableId) => {
    try {
      setLoadingContribuableTaxes(true);
      const response = await axios.get(`${API_BASE_URL}/taxpayers/${contribuableId}/taxes`, {
        headers: getHeaders(),
      });
      if (Array.isArray(response.data)) setSelectedContribuableTaxes(response.data);
    } catch (error) {
      setSelectedContribuableTaxes([]);
    } finally {
      setLoadingContribuableTaxes(false);
    }
  };

  const openCancelConfirmation = (paiement) => {
    setPaymentToCancel(paiement);
    setCancelReason("");
    setCancelReasonError("");
    setShowCancelConfirmModal(true);
  };

  const handleViewDetails = async (paiement) => {
    setLoadingDetailsId(paiement.id);
    setSelectedPaiement(paiement);
    setEcheanceDetails(null);

    try {
      const paymentDetailsResponse = await axios.get(
        `${API_BASE_URL}/payments/${paiement.reference_paiement}`,
        {
          headers: getHeaders(),
          params: { market_scope: effectiveMarketScope() },
        }
      );

      if (paymentDetailsResponse.data && paymentDetailsResponse.data.paiement) {
        const fullPaiement = paymentDetailsResponse.data.paiement;
        setSelectedPaiement((prev) => ({
          ...prev,
          ...fullPaiement,
          contribuable: fullPaiement.contribuable || prev.contribuable,
          taxe: fullPaiement.taxe || prev.taxe,
          activite: fullPaiement.activite || prev.activite,
          echeance: fullPaiement.echeance || prev.echeance,
          nom_activite:
            fullPaiement.activite?.name ||
            fullPaiement.activite?.nom ||
            fullPaiement.nom_activite ||
            fullPaiement.contribuable?.activite_contribuable ||
            "Activité non spécifiée",
          echeance_montant_initial: fullPaiement.echeance?.montant_initial,
          echeance_montant_paye: fullPaiement.echeance?.montant_paye,
          echeance_restant: fullPaiement.echeance?.montant_restant,
        }));

        if (fullPaiement.usager_id || paiement.usager_id) {
          const usagerId = fullPaiement.usager_id || paiement.usager_id;
          await fetchContribuableTaxes(usagerId);
          await fetchContribuableLocalite({
            localite_id: fullPaiement.contribuable?.localite_id || paiement.localite_id,
            adresse: fullPaiement.contribuable?.adresse || paiement.adresse,
          });
          if (fullPaiement.echeance_id || paiement.echeance_id) {
            await loadEcheanceDetails(
              usagerId,
              fullPaiement.taxe_id || paiement.taxe_id,
              fullPaiement.echeance_id || paiement.echeance_id
            );
          }
        }
      }
    } catch (error) {
      console.error("❌ Erreur chargement détails complets:", error);
      showAlert("Erreur lors du chargement des détails", "danger");
    }

    setShowDetailsModal(true);
    setLoadingDetailsId(null);
  };

  // ==================== COMPOSANTS ====================
  const SortableHeader = ({ field, children }) => (
    <th style={{ cursor: "pointer", userSelect: "none" }} onClick={() => handleSort(field)}>
      {children}
      {sortField === field && (
        <span className="ms-1">
          {sortDirection === "asc" ? <ChevronUp size={12} /> : <ChevronDown size={12} />}
        </span>
      )}
    </th>
  );

  const ResponsivePagination = () => {
    if (pagination.last_page <= 1) return null;

    const getPageNumbers = () => {
      const delta = 2;
      const range = [];
      const rangeWithDots = [];
      let l;

      if (pagination.last_page <= 7) {
        for (let i = 1; i <= pagination.last_page; i++) range.push(i);
        return range;
      }

      for (let i = 1; i <= pagination.last_page; i++) {
        if (
          i === 1 ||
          i === pagination.last_page ||
          (i >= pagination.current_page - delta && i <= pagination.current_page + delta)
        ) {
          range.push(i);
        }
      }

      range.forEach((i) => {
        if (l) {
          if (i - l === 2) rangeWithDots.push(l + 1);
          else if (i - l !== 1) rangeWithDots.push("...");
        }
        rangeWithDots.push(i);
        l = i;
      });

      return rangeWithDots;
    };

    return (
      <Pagination className="mb-0 flex-wrap justify-content-center justify-content-sm-start">
        <Pagination.First
          disabled={pagination.current_page === 1}
          onClick={() => handlePageChange(1)}
          className="d-none d-sm-inline-block"
        />
        <Pagination.Prev
          disabled={pagination.current_page === 1}
          onClick={() => handlePageChange(pagination.current_page - 1)}
        />
        {getPageNumbers().map((item, index) => {
          if (item === "...") return <Pagination.Ellipsis key={`dots-${index}`} disabled />;
          return (
            <Pagination.Item
              key={item}
              active={item === pagination.current_page}
              onClick={() => handlePageChange(item)}
              className="d-none d-sm-inline-block"
            >
              {item}
            </Pagination.Item>
          );
        })}
        <span className="d-inline-block d-sm-none mx-2 text-muted small">
          Page {pagination.current_page} / {pagination.last_page}
        </span>
        <Pagination.Next
          disabled={pagination.current_page === pagination.last_page}
          onClick={() => handlePageChange(pagination.current_page + 1)}
        />
        <Pagination.Last
          disabled={pagination.current_page === pagination.last_page}
          onClick={() => handlePageChange(pagination.last_page)}
          className="d-none d-sm-inline-block"
        />
      </Pagination>
    );
  };

  // ==================== RENDU ====================
  return (
    <React.Fragment>
      <Header />

      <ToastContainer
        className="p-3"
        style={{ zIndex: 9999, position: "fixed", top: "20px", right: "20px" }}
      >
        <Toast
          show={alertMessage.show}
          onClose={() => setAlertMessage((prev) => ({ ...prev, show: false }))}
          bg={alertMessage.type}
          delay={4000}
          autohide
        >
          <Toast.Header>
            <strong className="me-auto">Notification</strong>
          </Toast.Header>
          <Toast.Body className="text-white">{alertMessage.message}</Toast.Body>
        </Toast>
      </ToastContainer>

      <div className="main main-app p-3 p-lg-4">
        <div className="container-fluid">
          {/* En-tête */}
          <Row className="mb-4">
            <Col md={12}>
              <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center">
                <div className="mb-3 mb-md-0">
                  <ol className="breadcrumb fs-sm mb-1">
                    <li className="breadcrumb-item">
                      <Link to="/admin/dashboard">Tableau de bord</Link>
                    </li>
                    <li className="breadcrumb-item active">Historique des Paiements</li>
                  </ol>
                  <h4 className="main-title mb-0">
                    <ClockHistory className="me-2" />
                    Historique des Paiements
                  </h4>
                  <p className="text-muted mb-0">
                    Consultez l'historique des paiements et transactions
                  </p>
                </div>

                <div className="d-flex flex-wrap gap-2 align-items-center">
                  {/* ✅ Sélecteur de périmètre marché — Admin Entité + Super Admin UNIQUEMENT */}
                  {canUseMarketScope && (
                    <div className="d-flex align-items-center gap-2">
                      {/* <span
                        className="text-muted fw-semibold"
                        style={{ fontSize: "12px", whiteSpace: "nowrap" }}
                      >
                        <Shop className="me-1" size={14} />
                        Périmètre :
                      </span> */}
                      <Form.Select
                        value={marketScope}
                        onChange={(e) => setMarketScope(e.target.value)}
                        style={{ minWidth: "180px" }}
                        size="sm"
                      >
                        <option value="all">Tous les contribuables</option>
                        <option value="no_market">Hors marché uniquement</option>
                        <option value="market">De marché uniquement</option>
                      </Form.Select>

                      {isSuperAdmin && (
                        <Badge bg="dark" className="px-2 py-1" style={{ fontSize: "10px" }}>
                          Super Admin
                        </Badge>
                      )}
                    </div>
                  )}

                  <Button
                    variant="outline-primary"
                    onClick={() => setShowFilters(!showFilters)}
                    className="d-flex align-items-center"
                  >
                    <Filter className="me-2" />
                    Filtres {showFilters ? <ChevronUp className="ms-1" /> : <ChevronDown className="ms-1" />}
                  </Button>
                  <Button
                    variant="success"
                    className="d-flex align-items-center"
                    onClick={handleExportCSV}
                    disabled={loadingExport}
                  >
                    {loadingExport ? (
                      <Spinner animation="border" size="sm" className="me-2" />
                    ) : (
                      <Download className="me-2" />
                    )}
                    Exporter CSV
                  </Button>
                </div>
              </div>
            </Col>
          </Row>

          {/* Cartes statistiques */}
          <Row className="g-3 mb-4">
            <Col md={3}>
              <Card className="border-0 shadow-sm overflow-hidden stats-card">
                <div className="card-gradient bg-primary"></div>
                <Card.Body>
                  <h6 className="text-uppercase text-muted mb-2">Total Transactions</h6>
                  <h4 className="mb-0">
                    {loadingStats ? <Spinner animation="border" size="sm" /> : stats.totalPaiements}
                  </h4>
                </Card.Body>
              </Card>
            </Col>
            <Col md={3}>
              <Card className="border-0 shadow-sm overflow-hidden stats-card">
                <div className="card-gradient bg-info"></div>
                <Card.Body>
                  <h6 className="text-uppercase text-muted mb-2">Montant Total</h6>
                  <h4 className="mb-0">
                    {loadingStats ? (
                      <Spinner animation="border" size="sm" />
                    ) : (
                      formatCurrency(stats.totalMontant)
                    )}
                  </h4>
                </Card.Body>
              </Card>
            </Col>
            <Col md={3}>
              <Card className="border-0 shadow-sm overflow-hidden stats-card">
                <div className="card-gradient bg-success"></div>
                <Card.Body>
                  <h6 className="text-uppercase text-muted mb-2">Montant Collecté</h6>
                  <h4 className="mb-0 text-success">
                    {loadingStats ? (
                      <Spinner animation="border" size="sm" />
                    ) : (
                      formatCurrency(stats.montantCollecte || 0)
                    )}
                  </h4>
                </Card.Body>
              </Card>
            </Col>
            <Col md={3}>
              <Card className="border-0 shadow-sm overflow-hidden stats-card">
                <div className="card-gradient bg-danger"></div>
                <Card.Body>
                  <h6 className="text-uppercase text-muted mb-2">Montant Non Collecté</h6>
                  <h4 className="mb-0 text-danger">
                    {loadingStats ? (
                      <Spinner animation="border" size="sm" />
                    ) : (
                      formatCurrency(stats.montantNonCollecte || 0)
                    )}
                  </h4>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Bandeau d'info — périmètre actif */}
          {canUseMarketScope && marketScope !== "all" && (
            <Row className="mb-3">
              <Col md={12}>
                <div
                  className={`alert ${
                    marketScope === "no_market" ? "alert-primary" : "alert-success"
                  } d-flex align-items-center py-2 mb-0`}
                  role="alert"
                >
                  <Shop className="me-2" size={18} />
                  <div>
                    <strong>Périmètre actif :</strong>{" "}
                    {marketScope === "no_market"
                      ? "Contribuables hors marché uniquement"
                      : "Contribuables de marché uniquement"}
                    {isSuperAdmin && <span className="ms-2 badge bg-dark">Super Admin</span>}
                  </div>
                  <Button
                    variant="link"
                    size="sm"
                    className="ms-auto text-decoration-none p-0"
                    onClick={() => setMarketScope("all")}
                  >
                    Réinitialiser au périmètre global
                  </Button>
                </div>
              </Col>
            </Row>
          )}

          {/* Filtres avancés */}
          {showFilters && (
            <Row className="mb-4">
              <Col md={12}>
                <Card className="border-0 shadow-sm">
                  <Card.Header className="bg-light d-flex justify-content-between align-items-center">
                    <h6 className="mb-0">
                      <Filter className="me-2" />
                      Filtres avancés
                    </h6>
                    <Button variant="outline-secondary" size="sm" onClick={resetFilters}>
                      Réinitialiser
                    </Button>
                  </Card.Header>
                  <Card.Body>
                    <Row className="g-3">
                      <Col md={3}>
                        <FloatingLabel label="Date début">
                          <Form.Control
                            type="date"
                            value={filters.dateDebut}
                            onChange={(e) => setFilters({ ...filters, dateDebut: e.target.value })}
                          />
                        </FloatingLabel>
                      </Col>
                      <Col md={3}>
                        <FloatingLabel label="Date fin">
                          <Form.Control
                            type="date"
                            value={filters.dateFin}
                            onChange={(e) => setFilters({ ...filters, dateFin: e.target.value })}
                          />
                        </FloatingLabel>
                      </Col>
                      <Col md={2}>
                        <FloatingLabel label="Statut">
                          <Form.Select
                            value={filters.statut}
                            onChange={(e) => setFilters({ ...filters, statut: e.target.value })}
                          >
                            <option value="">Tous</option>
                            <option value="completed">Réussi</option>
                            <option value="failed">Échoué</option>
                            <option value="pending">En attente</option>
                            <option value="cancelled">Annulé</option>
                          </Form.Select>
                        </FloatingLabel>
                      </Col>
                      <Col md={2}>
                        <FloatingLabel label="Méthode">
                          <Form.Select
                            value={filters.methode}
                            onChange={(e) => setFilters({ ...filters, methode: e.target.value })}
                          >
                            <option value="">Toutes</option>
                            <option value="AM">Airtel Money</option>
                            <option value="card">Carte bancaire</option>
                            <option value="cash">Espèces</option>
                          </Form.Select>
                        </FloatingLabel>
                      </Col>
                      <Col md={2}>
                        <FloatingLabel label="Taxe">
                          <Form.Select
                            value={filters.taxeId}
                            onChange={(e) => setFilters({ ...filters, taxeId: e.target.value })}
                          >
                            <option value="">Toutes</option>
                            {filterOptions.taxes.map((taxe) => (
                              <option key={taxe.taxe_id} value={taxe.taxe_id}>
                                {taxe.titre}
                              </option>
                            ))}
                          </Form.Select>
                        </FloatingLabel>
                      </Col>
                    </Row>
                    <Row className="g-3 mt-3">
                      <Col md={3}>
                        <FloatingLabel label="Montant min">
                          <Form.Control
                            type="number"
                            placeholder="0"
                            value={filters.montantMin}
                            onChange={(e) => setFilters({ ...filters, montantMin: e.target.value })}
                          />
                        </FloatingLabel>
                      </Col>
                      <Col md={3}>
                        <FloatingLabel label="Montant max">
                          <Form.Control
                            type="number"
                            placeholder="9999999"
                            value={filters.montantMax}
                            onChange={(e) => setFilters({ ...filters, montantMax: e.target.value })}
                          />
                        </FloatingLabel>
                      </Col>
                      <Col md={3}>
                        <FloatingLabel label="Contribuable">
                          <Form.Select
                            value={filters.contribuableId}
                            onChange={(e) => setFilters({ ...filters, contribuableId: e.target.value })}
                          >
                            <option value="">Tous</option>
                            {filterOptions.contribuables.map((contrib) => (
                              <option key={contrib.contribuable_id} value={contrib.contribuable_id}>
                                {contrib.nom_contribuable}
                              </option>
                            ))}
                          </Form.Select>
                        </FloatingLabel>
                      </Col>
                      <Col md={3} className="d-flex align-items-end">
                        <Button
                          variant="primary"
                          onClick={() => setShowFilters(false)}
                          className="w-100"
                        >
                          Appliquer
                        </Button>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          )}

          {/* Barre de recherche */}
          <Row className="mb-4">
            <Col md={12}>
              <Card className="border-0 shadow-sm">
                <Card.Body>
                  <Row className="g-3">
                    <Col md={8}>
                      <InputGroup>
                        <InputGroup.Text>
                          <Search />
                        </InputGroup.Text>
                        <Form.Control
                          type="text"
                          placeholder="Rechercher par référence, contribuable, taxe, téléphone..."
                          value={filterText}
                          onChange={(e) => setFilterText(e.target.value)}
                        />
                      </InputGroup>
                    </Col>
                    <Col md={2}>
                      <Form.Select
                        value={pagination.per_page}
                        onChange={(e) =>
                          setPagination((prev) => ({
                            ...prev,
                            per_page: Number(e.target.value),
                            current_page: 1,
                          }))
                        }
                      >
                        <option value="10">10 / page</option>
                        <option value="25">25 / page</option>
                        <option value="50">50 / page</option>
                        <option value="100">100 / page</option>
                      </Form.Select>
                    </Col>
                    <Col md={2}>
                      <Button variant="outline-secondary" onClick={resetFilters} className="w-100">
                        Réinitialiser
                      </Button>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Tableau principal */}
          <Row>
            <Col md={12}>
              <Card className="shadow-sm border-0">
                <Card.Header className="bg-primary text-white d-flex justify-content-between align-items-center py-3">
                  <div className="d-flex align-items-center">
                    <ClockHistory className="me-2" />
                    <span className="fw-semibold">
                      Historique des Paiements ({pagination.total})
                    </span>
                  </div>
                  <Button
                    variant="outline-light"
                    size="sm"
                    onClick={() => loadCollectes(pagination.current_page)}
                    disabled={loading}
                  >
                    {loading ? (
                      <Spinner animation="border" size="sm" className="me-2" />
                    ) : (
                      <ClockHistory className="me-2" />
                    )}
                    {loading ? "Chargement..." : "Rafraîchir"}
                  </Button>
                </Card.Header>
                <Card.Body className="p-0">
                  <div className="table-responsive">
                    <Table hover className="mb-0">
                      <thead className="bg-light">
                        <tr>
                          <SortableHeader field="reference_paiement">Référence</SortableHeader>
                          <SortableHeader field="date_paiement">Date</SortableHeader>
                          <SortableHeader field="nom_contribuable">Contribuable</SortableHeader>
                          <th>Taxe</th>
                          <th>Période</th>
                          <SortableHeader field="montant">Montant</SortableHeader>
                          <th>Statut</th>
                          <th>Méthode</th>
                          <th style={{ width: "100px" }}>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          <tr>
                            <td colSpan="9" className="text-center py-5">
                              <Spinner animation="border" variant="primary" />
                              <p className="mt-2">Chargement...</p>
                            </td>
                          </tr>
                        ) : paiements.length > 0 ? (
                          paiements.map((paiement) => (
                            <tr
                              key={paiement.id}
                              className={
                                paiement.statut === "failed"
                                  ? "table-danger"
                                  : paiement.statut === "pending"
                                  ? "table-warning"
                                  : ""
                              }
                            >
                              <td>
                                <code className="fw-semibold">
                                  {paiement.reference_paiement || `PAY-${paiement.id}`}
                                </code>
                              </td>
                              <td>
                                <small className="text-muted">
                                  {formatDate(paiement.date_paiement)}
                                </small>
                              </td>
                              <td>
                                <div className="d-flex align-items-center">
                                  <Person className="me-2 text-muted" size={14} />
                                  <div>
                                    <strong>
                                      {paiement.nom_contribuable?.toLocaleUpperCase("fr-FR") ||
                                        "Non spécifié"}
                                    </strong>
                                    {paiement.client_phone && (
                                      <small className="d-block text-muted">
                                        <Phone size={12} className="me-1" />
                                        {paiement.client_phone}
                                      </small>
                                    )}
                                  </div>
                                </div>
                              </td>
                              <td>
                                <Badge bg="info" className="mb-1">
                                  {paiement.taxe_titre || "Non spécifié"}
                                </Badge>
                              </td>
                              <td>
                                <small className="text-muted">
                                  {paiement.echeance_periode
                                    }
                                </small>
                              </td>
                              <td>
                                <div className="d-flex align-items-center">
                                  {paiement.statut === "completed" ? (
                                    <ArrowDownCircle className="me-2 text-success" size={16} />
                                  ) : paiement.statut === "failed" ? (
                                    <ArrowUpCircle className="me-2 text-danger" size={16} />
                                  ) : (
                                    <ClockHistory className="me-2 text-warning" size={16} />
                                  )}
                                  <strong>{formatCurrency(paiement.montant)}</strong>
                                </div>
                              </td>
                              <td>{getStatusBadge(paiement.statut)}</td>
                              <td>
                                <small>{getPaymentMethodName(paiement.methode)}</small>
                              </td>
                              <td>
                                <div className="d-flex gap-1">
                                  <Button
                                    size="sm"
                                    variant="outline-primary"
                                    title="Voir détails"
                                    onClick={() => handleViewDetails(paiement)}
                                    style={{ width: "32px", height: "32px" }}
                                    disabled={loadingDetailsId === paiement.id}
                                  >
                                    {loadingDetailsId === paiement.id ? (
                                      <Spinner
                                        animation="border"
                                        size="sm"
                                        style={{ width: "12px", height: "12px" }}
                                      />
                                    ) : (
                                      <Eye size={14} />
                                    )}
                                  </Button>

                                  {paiement.statut === "completed" && (
                                    <>
                                      <Button
                                        size="sm"
                                        variant="outline-success"
                                        title="Imprimer reçu"
                                        onClick={() => generateBordereauPaiement(paiement)}
                                        style={{ width: "32px", height: "32px" }}
                                        disabled={printingPaymentId === paiement.id}
                                      >
                                        {printingPaymentId === paiement.id ? (
                                          <Spinner
                                            animation="border"
                                            size="sm"
                                            style={{ width: "12px", height: "12px" }}
                                          />
                                        ) : (
                                          <Printer size={14} />
                                        )}
                                      </Button>

                                      <Button
                                        size="sm"
                                        variant="outline-warning"
                                        title="Note de perception"
                                        onClick={() => generateNotePerception(paiement)}
                                        style={{ width: "32px", height: "32px" }}
                                        disabled={printingPaymentId === paiement.id}
                                      >
                                        {printingPaymentId === paiement.id ? (
                                          <Spinner
                                            animation="border"
                                            size="sm"
                                            style={{ width: "12px", height: "12px" }}
                                          />
                                        ) : (
                                          <FileText size={14} />
                                        )}
                                      </Button>
                                    </>
                                  )}
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="9" className="text-center py-5">
                              <Receipt size={48} className="text-muted" />
                              <p className="mt-3 text-muted">AUCUN PAIEMENT TROUVÉ.</p>
                              {(filterText || Object.values(filters).some((v) => v)) && (
                                <Button variant="outline-primary" size="sm" onClick={resetFilters}>
                                  Réinitialiser la recherche
                                </Button>
                              )}
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>

                  {pagination.last_page > 1 && (
                    <div className="p-3 border-top">
                      <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center gap-3">
                        <div className="text-muted small text-center text-sm-start">
                          Affichage de {pagination.from} à {pagination.to} sur {pagination.total}{" "}
                          paiements
                        </div>
                        <ResponsivePagination />
                      </div>
                    </div>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>

        <style>{`
          .stats-card { position: relative; transition: transform 0.3s ease; border-radius: 12px; overflow: hidden; }
          .stats-card:hover { transform: translateY(-5px); box-shadow: 0 10px 20px rgba(0,0,0,0.1) !important; }
          .card-gradient { position: absolute; top: 0; left: 0; width: 100%; height: 4px; opacity: 0.8; }
        `}</style>

        {/* Modal détails */}
        <Modal show={showDetailsModal} onHide={() => setShowDetailsModal(false)} centered size="lg">
          <Modal.Header
            closeButton
            className="border-0 text-white"
            style={{ background: "linear-gradient(135deg, #0d6efd, #0b5ed7)" }}
          >
            <Modal.Title>
              <Eye className="me-2" size={20} />
              Détails du Paiement
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="bg-light" style={{ height: "500px", overflowY: "auto" }}>
            {selectedPaiement && (
              <>
                <div className="mb-4 text-center">
                  <h4 className="fw-bold mb-1">
                    {selectedPaiement.reference_paiement || `PAY-${selectedPaiement.id}`}
                  </h4>
                  <div className="d-flex justify-content-center gap-2 align-items-center mt-2">
                    {getStatusBadge(selectedPaiement.statut)}
                    <Badge bg="secondary" className="px-2 py-1">
                      {formatDate(selectedPaiement.date_paiement)}
                    </Badge>
                  </div>
                </div>

                {selectedPaiement.statut === "canceled" && selectedPaiement.reason && (
                  <div className="alert alert-secondary mb-4" role="alert">
                    <div className="d-flex align-items-start">
                      <XCircle className="me-2 mt-1" size={18} />
                      <div>
                        <strong className="d-block mb-1">Raison de l'annulation :</strong>
                        <span>{selectedPaiement.reason}</span>
                      </div>
                    </div>
                  </div>
                )}

                <Tabs defaultActiveKey="info" className="mb-4">
                  <Tab eventKey="info" title="Informations générales">
                    <Row className="g-3 mt-3">
                      <Col md={12}>
                        <Card className="border-0 shadow-sm">
                          <Card.Header className="bg-primary bg-opacity-10">
                            <div className="d-flex align-items-center">
                              <Person className="text-primary me-2" />
                              <span className="fw-semibold">Contribuable</span>
                            </div>
                          </Card.Header>
                          <Card.Body>
                            <Row>
                              <Col md={6}>
                                <div className="mb-2">
                                  <small className="text-muted text-uppercase d-block">
                                    Nom complet
                                  </small>
                                  <strong>
                                    {selectedPaiement.nom_contribuable || "Non spécifié"}
                                  </strong>
                                </div>
                                <div className="mb-2">
                                  <small className="text-muted text-uppercase d-block">
                                    Identifiant
                                  </small>
                                  <span>{selectedPaiement.usager_id || "N/A"}</span>
                                </div>
                              </Col>
                              <Col md={6}>
                                <div className="mb-2">
                                  <small className="text-muted text-uppercase d-block">
                                    <Phone className="me-1" size={12} />
                                    Téléphone
                                  </small>
                                  <span>
                                    {selectedPaiement.client_phone ||
                                      selectedPaiement.contribuable_telephone ||
                                      "Non spécifié"}
                                  </span>
                                </div>
                                <div className="mb-2">
                                  <small className="text-muted text-uppercase d-block">
                                    <Envelope className="me-1" size={12} />
                                    Email
                                  </small>
                                  <span>
                                    {selectedPaiement.contribuable_email || "Non spécifié"}
                                  </span>
                                </div>
                              </Col>
                            </Row>
                          </Card.Body>
                        </Card>
                      </Col>

                      <Col md={6}>
                        <Card className="border-0 shadow-sm h-100">
                          <Card.Header className="bg-info bg-opacity-10">
                            <div className="d-flex align-items-center">
                              <Tag className="text-info me-2" />
                              <span className="fw-semibold">Taxe</span>
                            </div>
                          </Card.Header>
                          <Card.Body>
                            <div className="mb-2">
                              <small className="text-muted text-uppercase d-block">
                                Désignation
                              </small>
                              <strong>{selectedPaiement.taxe_titre || "Non spécifié"}</strong>
                            </div>
                            <div className="mb-2">
                              <small className="text-muted text-uppercase d-block">
                                ID Taxe
                              </small>
                              <span>{selectedPaiement.taxe_id || "N/A"}</span>
                            </div>
                            <div className="mb-2">
                              <small className="text-muted text-uppercase d-block">
                                Période
                              </small>
                              <span>
                                {selectedPaiement.echeance_periode || "Non spécifiée"}
                              </span>
                            </div>
                          </Card.Body>
                        </Card>
                      </Col>

                      <Col md={6}>
                        <Card className="border-0 shadow-sm h-100">
                          <Card.Header className="bg-success bg-opacity-10">
                            <div className="d-flex align-items-center">
                              <CurrencyDollar className="text-success me-2" />
                              <span className="fw-semibold">Montants</span>
                            </div>
                          </Card.Header>
                          <Card.Body>
                            <div className="mb-2">
                              <small className="text-muted text-uppercase d-block">
                                Montant de la transaction
                              </small>
                              <h5 className="mb-0 text-success">
                                {formatCurrency(selectedPaiement.montant)}
                              </h5>
                            </div>
                            <div className="mb-2">
                              <small className="text-muted text-uppercase d-block">
                                Méthode de paiement
                              </small>
                              <span>{getPaymentMethodName(selectedPaiement.methode)}</span>
                            </div>
                            {selectedPaiement.payment_bank && (
                              <div className="mb-2">
                                <small className="text-muted text-uppercase d-block">
                                  Banque
                                </small>
                                <span>{selectedPaiement.payment_bank}</span>
                              </div>
                            )}
                          </Card.Body>
                        </Card>
                      </Col>

                      {echeanceDetails && (
                        <Col md={12}>
                          <Card className="border-0 shadow-sm">
                            <Card.Header className="bg-warning bg-opacity-10">
                              <div className="d-flex align-items-center">
                                <Calendar className="text-warning me-2" />
                                <span className="fw-semibold">Détails de l'échéance</span>
                              </div>
                            </Card.Header>
                            <Card.Body>
                              <Row>
                                <Col md={4}>
                                  <div className="text-center p-3 bg-light rounded-3">
                                    <small className="text-muted text-uppercase d-block">
                                      Total échéance
                                    </small>
                                    <strong className="text-primary fs-5">
                                      {formatCurrency(echeanceDetails.montant_initial)}
                                    </strong>
                                  </div>
                                </Col>
                                <Col md={4}>
                                  <div className="text-center p-3 bg-light rounded-3">
                                    <small className="text-muted text-uppercase d-block">
                                      Déjà payé
                                    </small>
                                    <strong className="text-success fs-5">
                                      {formatCurrency(echeanceDetails.total_paye)}
                                    </strong>
                                  </div>
                                </Col>
                                <Col md={4}>
                                  <div className="text-center p-3 bg-light rounded-3">
                                    <small className="text-muted text-uppercase d-block">
                                      Reste à payer
                                    </small>
                                    <strong className="text-danger fs-5">
                                      {formatCurrency(echeanceDetails.reste)}
                                    </strong>
                                  </div>
                                </Col>
                              </Row>
                              <div className="mt-3">
                                <div className="d-flex justify-content-between mb-1">
                                  <small>Progression</small>
                                  <small className="text-success">
                                    {echeanceDetails.pourcentage.toFixed(1)}%
                                  </small>
                                </div>
                                <ProgressBar
                                  now={echeanceDetails.pourcentage}
                                  variant="success"
                                  style={{ height: "8px", borderRadius: "4px" }}
                                />
                              </div>
                              {echeanceDetails.date_echeance && (
                                <div className="mt-3 text-center">
                                  <small className="text-muted">
                                    Date d'échéance : {formatDate(echeanceDetails.date_echeance)}
                                  </small>
                                </div>
                              )}
                            </Card.Body>
                          </Card>
                        </Col>
                      )}
                    </Row>
                  </Tab>

                  <Tab eventKey="agent" title="Agent collecteur">
                    <Row className="g-3 mt-3">
                      <Col md={12}>
                        <Card className="border-0 shadow-sm">
                          <Card.Header className="bg-secondary bg-opacity-10">
                            <div className="d-flex align-items-center">
                              <Person className="text-secondary me-2" />
                              <span className="fw-semibold">
                                Informations de l'agent collecteur
                              </span>
                            </div>
                          </Card.Header>
                          <Card.Body>
                            <Row>
                              <Col md={6}>
                                <div className="mb-3">
                                  <small className="text-muted text-uppercase d-block">
                                    Identité
                                  </small>
                                  <div className="p-3 bg-light rounded-3">
                                    <h6 className="mb-1 fw-bold">
                                      {selectedPaiement.admin_fname || ""}{" "}
                                      {selectedPaiement.admin_lname || ""}
                                    </h6>
                                    {selectedPaiement.code_agent_interne && (
                                      <small className="text-muted d-block">
                                        Code: {selectedPaiement.code_agent_interne}
                                      </small>
                                    )}
                                    {selectedPaiement.matricule_interne && (
                                      <small className="text-muted d-block">
                                        Matricule: {selectedPaiement.matricule_interne}
                                      </small>
                                    )}
                                  </div>
                                </div>
                              </Col>
                              <Col md={6}>
                                <div className="mb-3">
                                  <small className="text-muted text-uppercase d-block">
                                    Contact
                                  </small>
                                  <div className="p-3 bg-light rounded-3">
                                    <p className="mb-1">
                                      <Phone className="me-2" size={12} />
                                      {selectedPaiement.admin_phone || "Non spécifié"}
                                    </p>
                                    <p className="mb-0">
                                      <Envelope className="me-2" size={12} />
                                      {selectedPaiement.agent_email || "Non spécifié"}
                                    </p>
                                  </div>
                                </div>
                              </Col>
                              <Col md={12}>
                                <div className="mb-3">
                                  <small className="text-muted text-uppercase d-block">
                                    Structure
                                  </small>
                                  <div className="p-3 bg-light rounded-3">
                                    <p className="mb-0">
                                      <Building className="me-2" size={12} />
                                      {selectedPaiement.entite_nom || "Entité non spécifiée"}
                                    </p>
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </Card.Body>
                        </Card>
                      </Col>
                    </Row>
                  </Tab>

                  <Tab eventKey="taxes" title="Taxes du contribuable">
                    <Row className="g-3 mt-3">
                      <Col md={12}>
                        <Card className="border-0 shadow-sm">
                          <Card.Header className="bg-info bg-opacity-10">
                            <div className="d-flex align-items-center">
                              <FileText className="text-info me-2" />
                              <span className="fw-semibold">
                                Taxes associées au contribuable
                              </span>
                            </div>
                          </Card.Header>
                          <Card.Body>
                            {loadingContribuableTaxes ? (
                              <div className="text-center py-3">
                                <Spinner animation="border" />
                              </div>
                            ) : selectedContribuableTaxes.length > 0 ? (
                              <Table hover size="sm" responsive>
                                <thead className="table-light">
                                  <tr>
                                    <th>Nom de la taxe</th>
                                    <th>ID Taxe</th>
                                    <th>Montant</th>
                                    <th>Fréquence</th>
                                    <th>Statut</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {selectedContribuableTaxes.map((taxe, index) => (
                                    <tr key={index}>
                                      <td>
                                        <strong>{taxe.nom_taxe || "Non spécifié"}</strong>
                                      </td>
                                      <td>
                                        <code>{taxe.taxe_id}</code>
                                      </td>
                                      <td>{formatCurrency(taxe.montant_personnalise)}</td>
                                      <td>
                                        <Badge bg="info" className="px-2 py-1">
                                          {taxe.frequence}
                                        </Badge>
                                      </td>
                                      <td>
                                        <Badge
                                          bg={taxe.statut === "active" ? "success" : "secondary"}
                                          className="px-2 py-1"
                                        >
                                          {taxe.statut === "active" ? "Active" : "Inactive"}
                                        </Badge>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </Table>
                            ) : (
                              <div className="text-center text-muted py-4">
                                <FileText size={40} className="mb-2 opacity-25" />
                                <p>Aucune taxe trouvée pour ce contribuable</p>
                              </div>
                            )}
                          </Card.Body>
                        </Card>
                      </Col>
                    </Row>
                  </Tab>
                </Tabs>
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            {selectedPaiement &&
              selectedPaiement.statut !== "failed" &&
              selectedPaiement.statut !== "canceled" && (
                <Button
                  variant="danger"
                  onClick={() => openCancelConfirmation(selectedPaiement)}
                  disabled={cancellingPayment}
                  className="me-auto"
                >
                  {cancellingPayment ? (
                    <>
                      <Spinner animation="border" size="sm" className="me-2" />
                      Annulation...
                    </>
                  ) : (
                    <>
                      <XCircle className="me-2" />
                      Annuler le paiement
                    </>
                  )}
                </Button>
              )}
            <Button variant="secondary" onClick={() => setShowDetailsModal(false)}>
              Fermer
            </Button>
            {selectedPaiement?.statut === "completed" && (
              <>
                <Button
                  variant="warning"
                  onClick={() => {
                    setShowDetailsModal(false);
                    generateNotePerception(selectedPaiement);
                  }}
                  disabled={printingPaymentId === selectedPaiement?.id}
                  className="me-2"
                >
                  {printingPaymentId === selectedPaiement?.id ? (
                    <>
                      <Spinner animation="border" size="sm" className="me-2" />
                      Génération...
                    </>
                  ) : (
                    <>
                      <FileText className="me-2" />
                      Note de perception
                    </>
                  )}
                </Button>
                <Button
                  variant="primary"
                  onClick={() => {
                    setShowDetailsModal(false);
                    generateBordereauPaiement(selectedPaiement);
                  }}
                  disabled={printingPaymentId === selectedPaiement?.id}
                >
                  {printingPaymentId === selectedPaiement?.id ? (
                    <>
                      <Spinner animation="border" size="sm" className="me-2" />
                      Génération...
                    </>
                  ) : (
                    <>
                      <Printer className="me-2" />
                      Imprimer reçu
                    </>
                  )}
                </Button>
              </>
            )}
          </Modal.Footer>
        </Modal>

        {/* Modal confirmation annulation */}
        <Modal
          show={showCancelConfirmModal}
          onHide={() => {
            setShowCancelConfirmModal(false);
            setPaymentToCancel(null);
            setCancelReason("");
            setCancelReasonError("");
          }}
          centered
          size="md"
        >
          <Modal.Header closeButton className="bg-danger text-white border-0">
            <Modal.Title className="d-flex align-items-center">
              <ExclamationCircle className="me-2" size={24} />
              Confirmation d'annulation
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="pt-4 pb-3">
            <div className="text-center mb-3">
              <div className="bg-danger bg-opacity-10 rounded-circle p-3 d-inline-flex mb-3">
                <XCircle size={48} className="text-danger" />
              </div>
              <h5 className="fw-bold mb-2">Annuler le paiement</h5>
              <p className="text-muted mb-0">
                Êtes-vous sûr de vouloir annuler ce paiement ?
              </p>
            </div>
            <div className="alert alert-warning mt-3">
              <ExclamationCircle className="me-2" size={16} />
              <strong>Attention :</strong> Cette action est irréversible et mettra à jour le
              statut de l'échéance concernée.
            </div>
            {paymentToCancel && (
              <div className="bg-light p-3 rounded-3 mt-3">
                <div className="d-flex justify-content-between mb-2">
                  <span className="text-muted">Référence :</span>
                  <span className="fw-semibold font-monospace">
                    {paymentToCancel.reference_paiement}
                  </span>
                </div>
                <div className="d-flex justify-content-between mb-2">
                  <span className="text-muted">Montant :</span>
                  <span className="fw-semibold text-success">
                    {formatCurrency(paymentToCancel.montant)}
                  </span>
                </div>
                <div className="d-flex justify-content-between">
                  <span className="text-muted">Contribuable :</span>
                  <span className="fw-semibold">{paymentToCancel.nom_contribuable}</span>
                </div>
              </div>
            )}
            <div className="mt-4">
              <Form.Label className="fw-semibold">
                Raison de l'annulation <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={cancelReason}
                onChange={(e) => {
                  setCancelReason(e.target.value);
                  if (e.target.value.trim()) setCancelReasonError("");
                }}
                placeholder="Veuillez indiquer la raison de l'annulation (ex: erreur de montant, paiement en double, etc.)"
                isInvalid={!!cancelReasonError}
              />
              <Form.Control.Feedback type="invalid">{cancelReasonError}</Form.Control.Feedback>
              <Form.Text className="text-muted">
                Cette raison sera enregistrée dans les logs pour suivi
              </Form.Text>
            </div>
          </Modal.Body>
          <Modal.Footer className="border-0 pt-0">
            <Button
              variant="secondary"
              onClick={() => {
                setShowCancelConfirmModal(false);
                setPaymentToCancel(null);
                setCancelReason("");
                setCancelReasonError("");
              }}
            >
              Non, maintenir
            </Button>
            <Button variant="danger" onClick={handleCancelPayment} disabled={cancellingPayment}>
              {cancellingPayment ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Annulation en cours...
                </>
              ) : (
                <>
                  <XCircle className="me-2" />
                  Oui, annuler le paiement
                </>
              )}
            </Button>
          </Modal.Footer>
        </Modal>

        <Footer />
      </div>
    </React.Fragment>
  );
}